export const ROOT = '/';
export const BUILDING_PAGE = '/building';
export const ELEVATOR_PAGE = '/elevator';
export const DIMENSIONS_PAGE = '/dimensions';
export const PRODUCTS = '/products';
export const OVERVIEW = '/overview';
export const SUCCESS = '/success';